const getFileExtension = (fileName: string): string => {
  if (typeof fileName !== 'string') return ''

  const extension = fileName.toLowerCase().split('.').pop()

  if (!extension) return ''

  return extension
}

export default getFileExtension
